/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  staffId: "",
  name: "",
  email: "",
  mobileNumber: "",
  emiratesId: "",
  clearFilterFlag: 0,
};

const CspInfoFilterSlice = createSlice({
  name: "cspInfoFilter",
  initialState,
  reducers: {
    setJobId(state, action) {
      state.staffId = action.payload;
    },
    setName(state, action) {
      state.name = action.payload;
    },
    setEmail(state, action) {
      state.email = action.payload;
    },
    setMobileNumber(state, action) {
      state.mobileNumber = action.payload;
    },
    setEmiratesId(state, action) {
      state.emiratesId = action.payload;
    },
    setClearFilterFlag(state, action) {
      state.clearFilterFlag = action.payload;
    },
    reset(state) {
      state.staffId = "";
      state.name = "";
      state.email = "";
      state.mobileNumber = "";
      state.emiratesId = "";
      state.clearFilterFlag = 0;
    },
  },
});

export const {
  setJobId,
  setName,
  setEmail,
  setMobileNumber,
  setEmiratesId,
  setClearFilterFlag,
  reset,
} = CspInfoFilterSlice.actions;

export default CspInfoFilterSlice.reducer;
